var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{class:{
    'hide-border': !_vm.isAdminPanel,
    'elevation-2': _vm.elevate,
  },staticStyle:{"padding-top":"64px"},attrs:{"app":"","width":"300","expand-on-hover":"","permanent":""},on:{"transitionend":_vm.onTransition}},[_c('v-list',{staticClass:"pt-0",staticStyle:{"margin-bottom":"60px"}},_vm._l((_vm.items),function(entry,index){return _c('NavigationItem',{key:index,attrs:{"entry":entry}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }